import List from './ListTemplate';
import Edit from './EditTemplate';
import Detail from './DetailTemplate';

export { List, Edit, Detail };



// WEBPACK FOOTER //
// ./src/Templates/index.js